export const walletCodeErrMsg='Failed to fetch wallet code data';
export const customersErrMsg = "An error occurred while fetching customer names."
export const guid='00000000-0000-0000-0000-000000000000';
export const commonErrorMsg = "Something went wrong please try again!"